import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }
    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const one = <h1 className="m-0 mb-[30px] ml-1 text-accent font-mono text-[clamp(var(--fz-sm),5vw,var(--fz-md))] font-normal max-[480px]:mb-[20px] max-[480px]:ml-0.5">Hi, my name is</h1>;
  const two = <h2 className="big-heading">Muhammad Sarim.</h2>;
  const three = <h3 className="big-heading" style={{ marginTop: '10px', marginBottom: '20px', color: 'var(--slate)', lineHeight: '1.1' }}>Engineering intelligent solutions for a smarter digital future.</h3>;
  const four = (
    <p className="mt-5 max-w-[540px]">
      Software Engineer &{' '}
      <a href="https://www.nu.edu.pk/" target="_blank" rel="noreferrer">
        FAST-NUCES
      </a>{' '}
      Alumnus specializing in the intersection of Artificial Intelligence and Scalable Architecture.
      I design and deploy full-stack, cloud-native solutions that integrate machine learning into
      seamless user experiences. From training intelligent models to managing DevOps pipelines, I am
      dedicated to building high-performance systems that solve complex, real-world challenges.
    </p>
  );
  const five = (
    /* email-link class = bigButton styles (global.css) */
    <a
      className="email-link mt-[50px]"
      href="https://medium.com/@Muhammad.Sarim"
      target="_blank"
      rel="noreferrer">
      Check out my articles!
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <section className="hero-section flex flex-col items-start justify-center min-h-screen p-0 pt-[var(--nav-height)]"
      style={{ '--media-height': '700px' }}>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </section>
  );
};

export default Hero;
